<template>
  <div
      class="filter-list"
      v-if="platformOptionsLoaded() && brancheOptionsLoaded() && targetWordOptionsLoaded()"
  >
    <div
        v-if="this.isCompaniesPage() || this.isExperiencePage()"
        class="filter-wrapper"
    >
      <div class="filter-title">Zoeken</div>
      <div class="search-field">
        <input
            type="text"
            v-model="searchInput"
            v-on:input="searchInputChanged"
            :placeholder="'Zoeken'"
        />
        <span
            v-if="searchInput.length > 0"
            @click="clearSearchInput"
            class="search-clear-button clear_button"
        ><span class=""
        ><i><span>×</span></i></span
        ></span
        >
      </div>
    </div>
    <div
        v-if="this.isCompaniesPage() || this.isExperiencePage()"
        class="filter-wrapper"
    >
      <div class="filter-title">Min reviews</div>
      <div class="search-field">
        <input
            type="number"
            min="0"
            v-model="minReviewsInput"
            v-on:input="minReviewsInputChanged"
            :placeholder="'Min reviews'"
        />
        <span
            v-if="minReviewsInput > 0"
            @click="clearMinReviewsInput"
            class="min-reviews-clear-button clear_button"
        ><span class=""
        ><i><span>×</span></i></span
        ></span
        >
      </div>
    </div>
    <div v-show="this.isExperiencePage()" class="filter-wrapper">
      <div class="filter-title">Van</div>
      <Datepicker
          name="fromDatePicker"
          @input="datesChanged"
          :disabled-dates="fromDateDisabledDates"
          class="datepicker"
          placeholder="Van datum"
          :clear-button="true"
          v-model="fromDate"
      ></Datepicker>
    </div>
    <div v-if="this.isExperiencePage()" class="filter-wrapper">
      <div class="filter-title">Tot</div>
      <Datepicker
          name="tillDatePicker"
          @input="datesChanged"
          :disabled-dates="tillDateDisabledDates"
          class="datepicker"
          placeholder="Tot datum"
          :clear-button="true"
          selectLabel="Add"
          deselectLabel="Remove"
          v-model="tillDate"
      ></Datepicker>
    </div>
    <div v-if="this.isExperiencePage()" class="filter-wrapper">
      <div class="filter-title">Sentiment</div>
      <div class="filter-content">
        <div class="multiselect-container">
          <MultiSelect
              v-model="sentimentValue"
              :options="sentimentOptions"
              :multiple="false"
              :allowEmpty="true"
              @input="onSentimentChange"
              placeholder="Kies sentiment"
              selectLabel="Add"
              deselectLabel="Remove"
          ></MultiSelect>
        </div>
        <span
            v-if="sentimentValue !== null"
            @click="clearSentiment"
            class="sentiment_clear_button clear_button"
        ><span class=""
        ><i><span>×</span></i></span
        ></span
        >
      </div>
    </div>
    <div v-if="this.isExperiencePage()" class="filter-wrapper">
      <div class="filter-title">Platforms</div>
      <div class="filter-content">
        <div class="multiselect-container">
          <MultiSelect
              v-model="sourceValue"
              :options="sourceOptions"
              :taggable="true"
              :multiple="true"
              @tag="addPlatformTag"
              @input="onPlatformChange"
              placeholder="Kies platforms"
              selectLabel="Add"
              deselectLabel="Remove"
          ></MultiSelect>
        </div>
        <span
            v-if="sourceValue !== null && sourceValue.length !== 0"
            @click="clearPlatforms"
            class="platforms_clear_button clear_button"
        ><span class=""
        ><i><span>×</span></i></span
        ></span
        >
      </div>
    </div>

    <div
        v-if="this.isCompaniesPage() || this.isExperiencePage()"
        class="filter-wrapper"
    >
      <div class="filter-title">Branches</div>
      <div class="filter-content">
        <div class="multiselect-container">
          <MultiSelect
              v-model="brancheValue"
              :options="brancheOptions"
              :taggable="true"
              :multiple="true"
              selectLabel="Add"
              deselectLabel="Remove"
              @input="onBrancheChange"
              @tag="addBrancheTag"
              placeholder="Kies branches"
          ></MultiSelect>
        </div>
        <span
            v-if="brancheValue !== null && brancheValue.length !== 0"
            @click="clearBranches"
            class="branches_clear_button clear_button"
        ><span class=""
        ><i><span>×</span></i></span
        ></span
        >
      </div>
    </div>

    <div v-if="this.isExperiencePage()" class="filter-wrapper">
      <div class="filter-title">Woorden</div>
      <div class="filter-content">
        <div class="multiselect-container">
          <MultiSelect
              v-model="targetWordValue"
              :options="targetWordOptions"
              :taggable="true"
              :multiple="true"
              :searchable="true"
              selectLabel="Add"
              deselectLabel="Remove"
              @input="onTargetWordChange"
              @tag="addTargetWordTag"
              placeholder="Kies woorden"
          ></MultiSelect>
        </div>
        <span
            v-if="targetWordValue !== null && targetWordValue.length !== 0"
            @click="clearTargetWords"
            class="targetword_clear_button clear_button"
        ><span class=""
        ><i><span>×</span></i></span
        ></span
        >
      </div>
    </div>
  </div>
</template>

<script>
import MultiSelect from "vue-multiselect";
import Datepicker from "vuejs-datepicker";

export default {
  name: "Filters",
  components: {
    MultiSelect,
    Datepicker
  },
  props: {
    currentPage: "",
    targetWordOptions: Array,
    sourceOptions: Array,
    brancheOptions: Array,
  },
  data() {
    return {
      parentName: "",
      key: 0,
      targetWordsLoaded: false,
      sourceLoaded: false,
      searchInput: "",
      minReviewsInput: "",
      sentimentValue: null,
      sentimentOptions: ["Positief", "Negatief", "Neutraal", "Niet beoordeelt"],
      targetWordValue: null,
      sourceValue: null,
      brancheValue: null,
      brancheLoaded: false,
      currentDate: null,
      fromDate: null,
      tillDate: null,
      doneTypingTimeout: null,
      tillDateDisabledDates: {
        from: new Date(),
        to: new Date(2019, 0, 1),
      },
      fromDateDisabledDates: {
        from: new Date(),
        to: new Date(2019, 0, 1),
      },
    };
  },
  mounted() {
    if (this.$route.fullPath.includes('reviews')) {
      this.loadExperiencesFilters();
      setTimeout(() => {
        this.currentPage.loadPosts();
      }, 100);
    }
    if (this.$route.fullPath.includes('companies') ||
        this.$route.fullPath.includes('exact') ||
        this.$route.fullPath.includes('favorite')) {
      this.loadCompanyFilters();
      setTimeout(() => {
        this.currentPage.loadCompanies();
      }, 100);
    }
  },
  methods: {
    loadCompanyFilters() {
      let organisationsFilterString = localStorage.getItem('organisationsFilter');
      let organisationsFilter = JSON.parse(organisationsFilterString);

      if (organisationsFilter !== null) {
        if (organisationsFilter.min_reviews !== null) {
          this.minReviewsInput = organisationsFilter.min_reviews;
        }
        if (organisationsFilter.search !== null) {
          this.searchInput = organisationsFilter.search;
        }
        if (organisationsFilter.branches !== null && organisationsFilter.branches.length !== 0) {
          this.brancheValue = organisationsFilter.branches;
        }
      }
    },
    loadExperiencesFilters() {
      let postsFilterString = localStorage.getItem('postsFilter');
      let postsFilter = JSON.parse(postsFilterString);

      if (postsFilter !== null) {
        if (postsFilter.search !== null) {
          this.searchInput = postsFilter.search;
        }

        if (postsFilter.min_reviews !== null) {
          this.minReviewsInput = postsFilter.min_reviews;
        }

        if (postsFilter.platforms !== null && postsFilter.platforms.length !== 0) {
          this.sourceValue = postsFilter.platforms
        }

        if (postsFilter.branches !== null && postsFilter.branches.length !== 0) {
          this.brancheValue = postsFilter.branches
        }

        if (postsFilter.woorden !== null && postsFilter.woorden.length !== 0) {
          this.targetWordValue = postsFilter.woorden
        }

        if (postsFilter.sentiment !== null && postsFilter.sentiment.length !== 0) {
          this.sentimentValue = postsFilter.sentiment
        }

        if (postsFilter.time.from !== null) {
          this.fromDate = Date.parse(postsFilter.time.from);
        }

        if (postsFilter.time.till) {
          this.tillDate = Date.parse(postsFilter.time.till);
        }
      }
    },
    targetWordOptionsLoaded() {
      return this.targetWordOptions != null
    },
    brancheOptionsLoaded() {
      return this.brancheOptions != null
    },
    platformOptionsLoaded() {
      return this.sourceOptions != null
    },
    isExperiencePage() {
      return this.currentPage.getName() === "Experiences";
    },
    isCompaniesPage() {
      return this.currentPage.getName() === "Companies";
    },
    filterAction() {
      let currentPageName = this.currentPage.getName();
      if (currentPageName === "Experiences") {
        localStorage.setItem('postsPage', 1 + '');
        this.getPostsFilterData();
        this.currentPage.loadPosts();
      }
      if (currentPageName === "Companies" ||
          currentPageName === "Exact" ||
          currentPageName === 'Favorites') {
        localStorage.setItem('organisationsPage', 1 + '');
        this.getOrganisationsFilterData();
        this.currentPage.loadCompanies();
      }
    },
    datesChanged() {
      this.filterAction();
    },
    addTargetWordTag(newTag) {
      const tag = {name: newTag};
      this.targetWordOptions.push(tag);
      this.targetWordValue.push(tag);
      this.filterAction();
    },
    addPlatformTag(newTag) {
      const tag = {name: newTag};
      this.sourceOptions.push(tag);
      this.sourceValue.push(tag);
      this.filterAction();
    },
    addBrancheTag(newTag) {
      const tag = {name: newTag};
      this.brancheOptions.push(tag);
      this.brancheValue.push(tag);
      this.filterAction();
    },
    searchInputChanged() {
      clearTimeout(this.doneTypingTimeout);
      this.doneTypingTimeout = setTimeout(this.filterAction, 750);
    },
    clearSearchInput() {
      this.searchInput = "";
      this.filterAction();
    },
    clearMinReviewsInput() {
      this.minReviewsInput = "";
      this.filterAction();
    },
    getOrganisationsFilterData() {
      let filter = {};
      filter["search"] = this.searchInput !== "" ? this.searchInput : null;
      filter["min_reviews"] =
          this.minReviewsInput !== "" ? parseInt(this.minReviewsInput) : null;
      filter["branches"] = this.brancheValue;

      localStorage.setItem('organisationsFilter', JSON.stringify(filter));

      return filter;
    },
    getPostsFilterData() {
      let filter = {};

      let tillDate = this.tillDate !== null ? new Date(this.tillDate) : null;
      let fromDate = this.fromDate !== null ? new Date(this.fromDate) : null;

      filter["search"] = this.searchInput !== "" ? this.searchInput : null;
      filter["min_reviews"] =
          this.minReviewsInput !== "" ? parseInt(this.minReviewsInput) : null;
      filter["time"] = {};
      filter["time"]["from"] =
          fromDate !== null
              ? fromDate.getFullYear() +
              "-" +
              (fromDate.getMonth() + 1) +
              "-" +
              fromDate.getDate()
              : null;
      filter["time"]["till"] =
          tillDate !== null
              ? tillDate.getFullYear() +
              "-" +
              (tillDate.getMonth() + 1) +
              "-" +
              tillDate.getDate()
              : null;
      filter["sentiment"] = this.sentimentValue;
      filter["platforms"] = this.sourceValue;
      filter["woorden"] = this.targetWordValue;
      filter["branches"] = this.brancheValue;

      localStorage.setItem('postsFilter', JSON.stringify(filter));

      return filter;
    },
    onPlatformChange() {
      this.filterAction();
    },
    onTargetWordChange() {
      this.filterAction();
    },
    onSentimentChange() {
      this.filterAction();
    },
    onBrancheChange() {
      this.filterAction();
    },
    minReviewsInputChanged() {
      clearTimeout(this.doneTypingTimeout);
      this.doneTypingTimeout = setTimeout(this.filterAction, 750);
    },
    clearSentiment() {
      this.sentimentValue = null;
      this.filterAction();
    },
    clearPlatforms() {
      this.sourceValue = null;
      this.filterAction();
    },
    clearTargetWords() {
      this.targetWordValue = null;
      this.filterAction();
    },
    clearBranches() {
      this.brancheValue = null;
      this.filterAction();
    }
  }
};
</script>
